import { Container, Row, Col } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { getImgCalendarCutoff } from "../../../services/ApiGetCalendarImgCutoff";
import { NotifyModal } from "../../../modal/NotifyModal";
import { ImgPreview } from "../../../model/datatype";
import { useTranslation } from "react-i18next";
import { protectedResources } from "../../../authConfig";

export const Menubar = () => {
  const [showModal, setShowModal] = useState(false);
  const [showMenu4, setMenu4] = useState("../images/menu4.svg");
  const [modalBackdrop, setModalBackdrop] = useState("true");
  const [modalKeyboard, setModalKeyboard] = useState(true);
  const [modalTitle, setModalTitle] = useState("");
  const [modalBody, setmodalBody] = useState("");
  const [modalConfirm, setModalConfirm] = useState(false);
  const [data, setData] = useState<ImgPreview | null>(null);
  const { t } = useTranslation();
  useEffect(() => {
    if (data === null) {
      getImgCalendarCutoff().then((response) => {
        const getData: any = response;
        // console.log(getData);
        setData(getData);
      });
    }
  });
  function handleView(e: any) {
    const urlPath = protectedResources.apiHRMobile.baseApi;
    setModalTitle(t("CalendarPupup"));
    setmodalBody("data:image/jpg;base64," + data?.cutOffCalendar.image);
    setModalBackdrop("true");
    setModalKeyboard(false);
    setModalConfirm(false);
    setShowModal(true);
    setMenu4("../images/menu4_active.svg");
  }

  const handleLogout = () => {
    setShowModal(false);
  };

  const handleOnExiting = () => {
    setMenu4("../images/menu4.svg");
  };

  const [pathname, setPathname] = useState("/");
  const location = useLocation();

  const url = location.pathname;
  const id = url.substring(url.lastIndexOf("/") + 1);

  useEffect(() => {
    setPathname(location.pathname);
  }, [location]);

  return (
    <>
      <NotifyModal
        btnConfirm="no"
        btnText="ปิด"
        type="images"
        keyboard={modalKeyboard}
        backdrop={modalBackdrop}
        confirm={modalConfirm}
        confirmFunc=""
        title={modalTitle}
        body={modalBody}
        showModal={showModal}
        handleContinue={handleLogout}
        onExiting={() => handleOnExiting()}
        onHide={() => setShowModal(false)}
        Style={{ background: "" }}
      />
      <div className="menubar">
        <Container className="menubar-box">
          <Row>
            <Col>
              <Link to={"/time_in_out/active1"}>
                {pathname === "/time_in_out/active1" ||
                pathname === "/time_in_out/active2" ||
                pathname === "/time_in_out/active3" ||
                pathname === "/time_in_out/active4" ? (
                  <img src={"../images/menu1_active.svg"} alt="Time" />
                ) : (
                  <img src="../images/menu1.svg" alt="Time" />
                )}
              </Link>
            </Col>
            <Col>
              <Link to="/salary">
                {pathname === "/salary" ? (
                  <img src="../images/menu2_active.svg" alt="SalaryRequest" />
                ) : (
                  <img src="../images/menu2.svg" alt="SalaryRequest" />
                )}
              </Link>
            </Col>
            <Col>
              <Link to="/">
                {pathname === "/" ? (
                  <img src="../images/menu3_active.svg" alt="Home" />
                ) : (
                  <img src="../images/menu3.svg" alt="Home" />
                )}
              </Link>
            </Col>
            <Col>
              <Link to="/anouncement">
                {pathname === "/anouncement" ||
                pathname === "/anouncement/" + id ? (
                  <img src="../images/menu4_active.svg" alt="news" />
                ) : (
                  <img src="../images/menu4.svg" alt="news" />
                )}
              </Link>
            </Col>
            <Col>
              <Link to="/service">
                {pathname === "/service" || pathname === "/service/" + id ? (
                  <img src="../images/menu5_active.svg" alt="news" />
                ) : (
                  <img src="../images/menu5.svg" alt="news" />
                )}
              </Link>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};
